export const InfoDrawerStyles = {
    container: {
        maxWidth: '800px',
    },
    titleContainer: {
        p: 3,
        backgroundColor: 'background.default',
        borderBottom: '1px solid',
        borderBottomColor: 'border.subtle',
    },
    objectContainer: {
        border: '1px solid',
        borderColor: 'border.primary',
        borderRadius: '6px',
        maxWidth: '600px',
        overflow: 'auto',
    },
}
